import api from './api';

type ApiEnvelope<T> = {
  success: boolean;
  data: T;
  message?: string;
};

function unwrapData<T>(response: any, fallback: T): T {
  const payload = response?.data ?? response?.result ?? response ?? fallback;
  return payload === null || payload === undefined ? fallback : (payload as T);
}

function envelope<T>(response: any, fallback: T): ApiEnvelope<T> {
  return {
    success: response?.success !== false,
    data: unwrapData(response, fallback),
    message: response?.message,
  };
}

function envelopeArray<T = any>(response: any): ApiEnvelope<T[]> {
  const data = unwrapData<any>(response, []);
  const payload = response?.snapshots ?? response?.items ?? data?.snapshots ?? data?.items ?? data;
  return {
    success: response?.success !== false,
    data: Array.isArray(payload) ? payload : [],
    message: response?.message,
  };
}

export async function getMemorySettings(params: { user_id: string; project_id?: string }) {
  const response = await api.get<{ success: boolean; data: any }>(`/juben/user/memory/settings`, params);
  return envelope(response, null);
}

export async function updateMemorySettings(payload: {
  user_id: string;
  project_id?: string;
  user_enabled?: boolean;
  project_enabled?: boolean;
}) {
  const response = await api.post<{ success: boolean; data: any }>(`/juben/user/memory/settings`, payload);
  return envelope(response, null);
}

export async function getMemoryMetrics(params: { user_id: string; session_id: string; query?: string }) {
  const response = await api.get<{ success: boolean; data: any }>(`/juben/user/memory/metrics`, params);
  return envelope(response, null);
}

export async function getMemoryQuality(params: { user_id: string; session_id: string; query?: string }) {
  const response = await api.get<{ success: boolean; data: any }>(`/juben/user/memory/quality`, params);
  return envelope(response, null);
}

export async function listMemorySnapshots(params: { user_id: string; session_id: string; project_id?: string }) {
  const response = await api.get<{ success: boolean; data: any[] }>(`/juben/user/memory/snapshots`, params);
  return envelopeArray(response);
}

export async function createMemorySnapshot(payload: {
  user_id: string;
  session_id: string;
  project_id?: string;
  label?: string;
}) {
  const response = await api.post<{ success: boolean; data: any }>(`/juben/user/memory/snapshots`, payload);
  return envelope(response, {});
}

export async function restoreMemorySnapshot(snapshotId: string, payload: { user_id: string; session_id: string }) {
  const response = await api.post<{ success: boolean; data: any }>(`/juben/user/memory/snapshots/${snapshotId}/restore`, payload);
  return envelope(response, {});
}
